<template>
  <section id="about">
    <div class="container">
      <div class="content-bg text-center avatar-section">
        <img class="avatar" src="../assets/images/8biticon.jpg" alt />
        <h2>Hey Folks!</h2>
        <p class="milli">My name is Shabnam. I'm a full-stack developer living in Montreal, Canada.
          <br />I have a great passion for building & designing websites & web apps.
          <br />I got a diploma in web development from Concordia university, but
          <br />I also learned a lot of things by myself. I always enjoy learning new things.
        </p>
        <p class="milli">My goal is to build nice, responsive & accessible projects.<br />I like keeping things simple, nice & neat.</p>
        <p class="milli">Feel free to take a look at my portfolio & hire me!:)</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About'
}
</script>
